<template>
  <div id="examPhotoQuery">
    <ots-main-title></ots-main-title>
    <ots-table-group-new
      :selectList="selectList"
      :requestForm="requestForm"
      :tableHeader="tableHeader"
      :tableData="tableData"
      :pagination="pagination"
      :batchOperBtn="batchOperBtn"
      @changeNum="changeNum"
      @changePage="changePage"
      @search="search"
    ></ots-table-group-new>

    <ots-custom-dialog :dialog.sync="uploadDialog" title="上传考试照片">
      <template v-slot:content>
        <div class="uploadClass">
          <p><span>考生姓名：</span>{{ uploadForm.realName }}</p>
          <p><span>证件号：</span>{{ uploadForm.cardNo }}</p>
          <div class="uploadImage">
            <span>试考照片：</span>
            <el-upload action="" :show-file-list="false" :before-upload="beforeAvatarUpload" :http-request="uploadImgUrl">
              <div class="photo" style="border: 1px dashed #d9d9d9; height: 152px;">
                <img v-if="uploadForm.photoUrl" :src="uploadForm.photoUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </div>
            </el-upload>
            <el-button type="primary" size="small" plain round style="width: 80px; height:32px;" @click="deleteUploadImage" v-if="uploadForm.photoUrl">删除照片</el-button>
          </div>
          <p><span></span>图片支持 <strong>JPG</strong>， <strong>JPEG</strong>， <strong>PNG</strong> 格式，文件最大不超过 <strong>2048 KB</strong></p>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="uploadDialog = false">取消</el-button>
        <el-button round type="primary" @click="rightUpload(true)">确定</el-button>
      </template>
    </ots-custom-dialog>

    <ots-custom-dialog :dialog.sync="BatchUploadDialog" title="批量上传试考照片">
      <template v-slot:content>
        <div class="BatchUpload">
          <el-form>
            <el-form-item label="选择批次：">
                <el-select v-model="planId" placeholder="请选择" :filterable="true">
                  <el-option
                    v-for="item in planList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="选择照片信息文件：">
              <el-upload
                action=""
                ref="upload"
                :multiple="multiple"
                :limit="limit"
                :http-request="httpRequest"
                :show-file-list="true"
                :before-upload="beforeUpload"
              >
                <template v-if="isHasSlot">
                  <slot></slot>
                </template>
                <div v-else class="default-upload-container">{{ getFileName }}</div>
              </el-upload>
            </el-form-item>
          </el-form>
        </div>
        <div style="padding-left: 8px;">
          <p>提示：</p>
          <p>1：只能上传文件名为 <span class="colorRed">.zip</span> 的文件；</p>
          <p>2：文件大小不能超过 <span class="colorRed">10M</span>；</p>
          <p>3：文件名不能是中文， <span class="colorRed">照片以证件号命名</span>；</p>
          <p>4：压缩包内只能是照片（不包含文件夹）；</p>
          <p>5：多批次导入照片以最后一次导入为准；</p>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="BatchUploadDialog = false">取消</el-button>
        <el-button round type="primary" @click="BatchUpload">确定</el-button>
      </template>
    </ots-custom-dialog>

  </div>
</template>

<script>
import { getSelectPlanFn } from "@/http/modules/examSet/examBatch";
import { getCurrentSelectPlace } from "@/http/modules/examSet/planClass";
import { getComputerExamClassListAPI, getComputerExamPhotoListAPI, uploadComputerExamSinglePhotoAPI, checkAllSessionIsEndAPI, uploadComputerExamBatchPhotoAPI } from "@/http/modules/computedRoomExam";

export default {
  data() {
    return {
      selectList: [
        {
          title: "批次名称",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: '考点名称',
          type: 'select',
          requestKey: 'placeId',
          label: 'name',
          value: 'id',
          data: [],
        },
        {
          title: '教室名称',
          type: 'select',
          requestKey: 'classId',
          label: 'className',
          value: 'classId',
          data: [],
        },
        {
          title: "关键词",
          type: "input",
          requestKey: "searchKey",
          placeholder: "姓名/证件号",
        },
      ],
      requestForm: {
        planId: "",
        placeId: "",
        classId: "",
        searchKey: "",
        page: 1,
        size: 10,
      },
      tableHeader: [
        {
          title: "考试批次",
          prop: "planName",
        },
        {
          title: "考点名称",
          prop: "placeName"
        },
        {
          title: "教室名称",
          prop: "className"
        },
        {
          title: "座位号",
          prop: "seatNo"
        },
        {
          title: "考生姓名",
          prop: "realName"
        },
        {
          title: "用户名",
          prop: "userName"
        },
        {
          title: "证件号",
          prop: "cardNo"
        },
        {
          title: "试考照片",
          type: "img",
          prop: "photoUrl",
          fixed: "right",
          width: "120"
        },
        {
          title:"操作",
          type:"buttons",
          width:"240",
          btnList:[
            { title: "上传试考照片", click: this.uploadTryExamImage },
          ]
        }
      ],
      tableData: [],
      pagination: {
        total: 0,
      },
      batchOperBtn: [
        {
          title: "批量上传试考照片",
          icon: "iconfont icon-shangchuan",
          click: this.uploadExamImage,
        },
      ],
      uploadDialog: false,
      uploadForm: {},
      planInfo: {},
      BatchUploadDialog: false,
      planList: [],
      multiple: false,
      limit: 1,
      file: "",
      name: "点击选择文件",
      planId: "",
      fileType: "zip",
    } 
  },
  computed: {
    isHasSlot() {
      return this.$slots.default && this.$slots.default.length;
    },
    getFileName() {
      if (this.multiple) {
        let newName = this.name.replace(/点击选择文件/g, "");
        return this.name === "点击选择文件" ? this.name : newName.substring(0, newName.lastIndexOf("、"));
      } else {
        return this.name;
      }
    },
  },
  watch: {
    'requestForm.planId': function(value) {
      this.getPlace(value);
      this.search();
    },
    'requestForm.placeId': function(value) {
      this.getClass();
    },
  },
  mounted() {
    this.initData();
  },
  methods:{
    // 初始化数据
    async initData() {
      // (1) 批次
      const { data: planData } = await getSelectPlanFn();
      this.selectList[0].data = planData;
      this.requestForm.planId = planData[0].id;
      this.planList = planData;
    },
    httpRequest(val) {
      this.file = val.file;
    },
    beforeUpload(file) {
      let isType = true;
      if (this.fileType) {
        isType = file.name.indexOf(this.fileType) > -1;
      }
      const isLimit = Math.floor(file.size / 1024 / 1024) < 10;
      if (!isType) {
        this.$message.error(`只能上传${this.fileType}文件!`);
      } else if (!isLimit) {
        this.$message.error("上传的压缩包文件大小不能超过 10M!");
      }
      let isOk = isType && isLimit;
      if (isOk) {
        this.name = file.name;
      }
      this.$refs.upload.clearFiles();
      return isOk;
    },
    // 获取考点
    async getPlace(value) {
      const { data: placeData } = await getCurrentSelectPlace({planId: value});
      if (!placeData) {
        this.selectList[1].data = [];
        this.requestForm.placeId = '';
        return;
      }
      this.selectList[1].data = [{id: '', name: '全部'}, ...placeData];
      this.requestForm.placeId = "";
    },

    // 获取教室
    async getClass() {
      let params = {
        planId: this.requestForm.planId,
        placeId: this.requestForm.placeId
      }
      const { data: classData } = await getComputerExamClassListAPI(params);
      if (classData.length === 0) {
        this.selectList[2].data = [];
        this.requestForm.classId = '';
        return;
      }
      this.selectList[2].data = [{classId: '', className: '全部'}, ...classData];
      this.requestForm.classId = '';
    },


    search() {
      this.requestForm.page = 1;
      this.getTableData();
    },

    // 批量上传
    async uploadExamImage() {
      this.planId = "";
      this.file = "";
      this.BatchUploadDialog = true;
    },

    // 批量上传，执行
    async BatchUpload() {
      if (!this.file) {
        this.$message.error("请选择 “ 照片信息 ” 压缩包文件！");
        return;
      }
      const formData = new FormData();
      let params = {
        file: this.file,
        planId: this.planId
      }
      for (let item in params) {
        formData.append(item, params[item]);
      }
      const {code} = await checkAllSessionIsEndAPI({ planId: this.planId })
      if (!code) {
        return false;
      }
      const res = await uploadComputerExamBatchPhotoAPI(formData);
      if (res.code) {
          this.BatchUploadDialog = false;
          const failNum = res.data.errorCount ? parseInt(res.data.errorCount): 0;
          const totalNum = parseInt(res.data.allCount);
          const successNum = totalNum - failNum;
          let message = `导入完成，成功导入${successNum}条。`;
          let errMessage = `导入失败：存在${failNum}条不符合要求的数据，请修改后重新导入试考照片。`;
          this.$confirm(failNum > 0 ? errMessage: message, "导入结果", {
            confirmButtonText: failNum > 0 ? "查看错误记录" : "确定",
            cancelButtonText: "取消",
            type: failNum > 0 ? "warning" : "success",
          }).then(() => {
            if (failNum > 0) {
              window.location.href = res.data.address;
            }
          });
          this.getTableData();
        }
    },

    // 上传试考照片
    async uploadTryExamImage(row) {
      const res = await checkAllSessionIsEndAPI({ planId: this.requestForm.planId })
      if (res.code) {
        this.uploadForm = { ...row }
        this.uploadDialog = true;
      }
    },

    // 照片上传
    beforeAvatarUpload(fileData) {
      let ImgRules = ["jpeg", "jpg", "png"];
      let type = fileData.name.substring(fileData.name.lastIndexOf(".") + 1);
      const isJPG = ImgRules.indexOf(type) !== -1;
      const isLt30kb = fileData.size / 1024 < 2048;
      if (!isJPG && !isLt30kb) {
        this.$message.error(`该批次上传图片只能是 JPEG，JPG，PNG 格式，且大小不能超过 2048 KB! `);
      } else if (!isJPG) {
        this.$message.error(`该批次上传图片只能是 JPEG，JPG，PNG 格式!`);
      } else if (!isLt30kb) {
        this.$message.error(`该批次上传图片大小不能超过 2048 KB!`);
      }
      return isJPG && isLt30kb;
    },

    uploadImgUrl(data) {
      let that = this;
      let fileData = data.file;
      let reader = new FileReader();
      reader.readAsDataURL(fileData);
      reader.onload = function (e) {
        if (e.currentTarget.result) {
          that.uploadForm.photoUrl = e.currentTarget.result;
        }
      };
    },


    // 单独上传照片
    async rightUpload(flag) {
      let params = {
        planId: this.requestForm.planId,
        userId: this.uploadForm.userId,
        userPhoto: this.uploadForm.photoUrl
      }
      if (params.userPhoto) {
        params.userPhoto = params.userPhoto.split(",")[1];
      }
      const { code } = await uploadComputerExamSinglePhotoAPI(params);
      if (code) {
        this.$message.success(`考生 ${this.uploadForm.realName} 试考照片${flag ? '上传': '删除'}成功！`);
        this.uploadDialog = false;
        this.getTableData();
        return;
      }

      return;
      if (code && !flag) {
        this.$message.success(`考生 ${this.uploadForm.realName} 试考照片删除成功！`);
        this.uploadDialog = false;
        this.getTableData();
        return;
      }
    },

    // 删除照片
    deleteUploadImage() {
      this.uploadForm.photoUrl = "";
      this.rightUpload(false);
    },

    async getTableData() {
      let params = { ...this.requestForm };
      const { code, data} = await getComputerExamPhotoListAPI(params);
      if (code) {
        this.tableData = data.records;
        this.pagination.total = data.total;
      }
    },

    changeNum(num) {
      this.requestForm.size = num
      this.getTableData()
    },

    changePage(p) {
      this.requestForm.page = p;
      this.getTableData();
    },
  }
}
</script>

<style scoped lang="less">
.uploadClass {
  p {
    margin-bottom: 16px;
    span {
      display: inline-block;
      width: 72px;
      text-align: right;
    }
    strong {
      color: #FE5859;
    }
  }
}

.uploadImage {
  display: flex;
  margin-bottom: 16px;
  span {
    display: inline-block;
    width: 72px;
    text-align: right;
  }
  .el-button {
    width: 80px;
    height: 32px;
    margin-top: 120px;
    margin-left: 16px;
  }
}

.colorRed {
  color: #FE5859;
}

/deep/ .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #006aff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 116px;
  height: 152px;
  line-height: 152px;
  text-align: center;
}
.avatar {
  width: 116px;
  height: 152px;
}
.avatarTip {
  display: flex;
  padding-top: 8px;
  vertical-align: top;
  line-height: 1.8;
}
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 116px;
  height: 152px;
}
.avatar-uploader /deep/ .el-upload:hover {
  border-color: #006aff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
}
.avatar-uploader /deep/ .el-upload:hover .avatar-uploader-icon {
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 3;
}
.default-upload-container {
  box-sizing: border-box;
  width: 280px;
  height: 40px;
  border-radius: 4px;
  border: 1px solid #dddddd;
  background: rgba(255, 255, 255, 0.35);
  color: #c2c4cc;
  font-size: 13px;
  line-height: 40px;
  text-align: left;
  padding-left: 12px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>